var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewPhoneBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 634,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_729_28641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.02417 56.6398C2.02417 25.3585 27.3827 0 58.6639 0H250.384C281.666 0 307.024 25.3585 307.024 56.6398V577.36C307.024 608.641 281.666 634 250.384 634H58.6639C27.3827 634 2.02417 608.641 2.02417 577.36V56.6398Z",
    fill: "#454545",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1741 56.9856C10.1741 30.0009 32.0495 8.12556 59.0342 8.12556H250.063C277.048 8.12556 298.923 30.0009 298.923 56.9856V577.014C298.923 603.999 277.048 625.874 250.063 625.874H59.0342C32.0495 625.874 10.1741 603.999 10.1741 577.014V56.9856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1741 56.9856C10.1741 30.0009 32.0495 8.12556 59.0342 8.12556H250.063C277.048 8.12556 298.923 30.0009 298.923 56.9856V577.014C298.923 603.999 277.048 625.874 250.063 625.874H59.0342C32.0495 625.874 10.1741 603.999 10.1741 577.014V56.9856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1741 56.9856C10.1741 30.0009 32.0495 8.12556 59.0342 8.12556H250.063C277.048 8.12556 298.923 30.0009 298.923 56.9856V577.014C298.923 603.999 277.048 625.874 250.063 625.874H59.0342C32.0495 625.874 10.1741 603.999 10.1741 577.014V56.9856Z",
    stroke: "black",
    strokeWidth: 8.25113
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.048584 123.915C0.048584 123.086 0.720249 122.415 1.54879 122.415H2.04858V145.253H1.54879C0.720249 145.253 0.048584 144.582 0.048584 143.753V123.915ZM0.048584 168.679C0.048584 167.85 0.720249 167.179 1.54879 167.179H2.04858V215.597H1.54879C0.720249 215.597 0.048584 214.925 0.048584 214.096V168.679ZM1.54879 228.386C0.720249 228.386 0.048584 229.058 0.048584 229.887V274.39C0.048584 275.219 0.720249 275.891 1.54879 275.891H2.04858V228.386H1.54879Z",
    fill: "#464646",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 200.98H307.5C308.328 200.98 309 201.652 309 202.48V275.304C309 276.133 308.328 276.804 307.5 276.804H307V200.98Z",
    fill: "#464646",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M239.025 0H244.025V4H239.025V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M303.025 67H307.025V71H303.025V67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.02515 67H6.02515V71H2.02515V67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.02515 564H6.02515V568H2.02515V564Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.0251 630H70.0251V634H66.0251V630Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M303.025 564H307.025V568H303.025V564Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_729_28641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 308.951,
    height: 634,
    fill: "white",
    transform: "translate(0.048584)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewPhoneBig);
export default __webpack_public_path__ + "static/media/preview-phone-big.9a01cb9f3a369d56d469d18dce038c61.svg";
export { ForwardRef as ReactComponent };